<script setup lang="ts">
import { UITextMdMedium, UITag } from '@gohighlevel/ghl-ui'
import { ClockRefreshIcon } from '@gohighlevel/ghl-icons/24/outline'

import i18n from '../../../locales'
import dayjs from 'dayjs'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})

const getReasonLabel = (reason: string) => {
  const reasonMap: Record<string, string> = {
    not_interested: i18n.global.t('common.notInterested'),
    pricing: i18n.global.t('common.pricing'),
    choose_another_vendor: i18n.global.t('common.chooseAnotherVendor'),
    timing_not_suitable: i18n.global.t('common.timingNotSuitable'),
    spam: i18n.global.t('common.spam'),
  }
  return reasonMap[reason] || reason
}
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium>
      <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        {{ data?.metaData?.email ? `(${data.metaData.email})` : '' }}
      </span>
      <span class="font-bold" v-else> {{ data.metaData.email }} </span>
      <span class="text-gray-500">{{
        i18n.global.t('proposalsList.eventLogs.declined')
      }}</span>
    </UITextMdMedium>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap gap-2 mb-2">
      <UITag
        v-for="reason in data?.metaData?.declinedReason"
        :key="reason"
        type="info"
        size="small"
      >
        {{ getReasonLabel(reason) }}
      </UITag>
    </div>

    <p
      v-if="data?.metaData?.declinedReasonBody"
      class="text-sm text-gray-600 mb-2 whitespace-pre-wrap"
    >
      {{ data.metaData.declinedReasonBody }}
    </p>

    <div class="flex justify-between items-end mt-3">
      <p class="text-sm text-gray-500">
        {{ dayjs(data.createdAt).format('MMMM DD, YYYY') }}
      </p>
      <UITag type="info" size="small" class="text-[8px] declined-event">
        <template #icon>
          <ClockRefreshIcon class="w-4 h-4 clock-icon"
        /></template>
        {{ i18n.global.t('common.declined') }}
      </UITag>
    </div>
  </div>
</template>

<style scoped lang="scss">
.declined-event {
  --n-text-color: rgb(239 68 68) !important;
  --n-color: rgb(254 226 226) !important;
  --n-border: 0px !important;
}
.clock-icon {
  color: rgb(239 68 68) !important;
}
</style>
